<template>
  <v-dialog v-model="dialog" :width="max ? '90%':'600'">
    <template v-slot:activator="{ on }">
      <a v-on="on">{{fileName}}</a>
    </template>
    <v-toolbar :loading="isAppLoading">
      <v-toolbar-title>PDF Preview - {{fileName}}</v-toolbar-title>
      <v-btn :href="pdfPath" target="_blank" icon>
          <v-icon>mdi-file-export-outline</v-icon>
        </v-btn>
      <v-spacer />
      <v-btn icon @click="max = !max">
        <v-icon>{{max ? 'mdi-arrow-collapse':'mdi-arrow-expand'}}</v-icon>
      </v-btn>
      <v-btn data-cy="closedialog" icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        
        <v-pagination
          class="mb-5"
          v-model="currentPage"
          :total-visible="10"
          :length="pageCount"
          circle
        ></v-pagination>
        
        <pdf
          :src="pdfSrc"
          @num-pages="pageCount = $event"
          @page-loaded="pageLoaded"
          :page="currentPage"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import pdf from "vue-pdf";
import PDFJS from "pdfjs-dist/webpack";

export default {
  props: {
    s3Path: {
      type: String,
      required: false
    },
    materialId: {
      type: Number,
      required: false
    },
    fileName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pdfSrc: null,
      currentPage: 1,
      pageCount: 0,
      pdfLoading: true,
      dialog: false,
      max: false,
      pdfPath: ''
    };
  },
  components: {
    pdf
  },
  watch: {
    dialog(dialog){
      if(dialog){
        //Load pdf when dialog opens and pdf hasn't been loaded yet.
        if(this.pdfSrc == null && this.materialId){
            this.pdfPath = `${process.env.VUE_APP_BASE_URL}/s3/get/${this.materialId}`;
            this.pdfSrc = this.createPdfLoadingTask(this.pdfPath);
          }
      }
    }
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "grades", "subjects"])
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage"]),
    pageLoaded(pageNumber) {
      this.currentPage = pageNumber;
      this.pdfLoading = false;
    },
    createPdfLoadingTask(src, options) {
      var source;
      if (typeof src === "string")
        source = { url: src, withCredentials: true, disableFontFace: true };
      else if (src instanceof Uint8Array)
        source = { data: src, withCredentials: true, disableFontFace: true };
      else if (typeof src === "object" && src !== null)
        source = Object.assign(
          { withCredentials: true, disableFontFace: true },
          src
        );
      else throw new TypeError("invalid src type");

      // source.verbosity = PDFJS.VerbosityLevel.INFOS;
      // source.pdfBug = true;
      // source.stopAtErrors = true;

      var loadingTask = PDFJS.getDocument(source);

      loadingTask.__PDFDocumentLoadingTask = true; // since PDFDocumentLoadingTask is not public

      if (options && options.onPassword)
        loadingTask.onPassword = options.onPassword;

      if (options && options.onProgress)
        loadingTask.onProgress = options.onProgress;

      loadingTask.promise
        .then(() => {})
        .catch(e => {
          console.log(e);
        });

      return loadingTask;
    }
  },
  mounted() {
  }
};
</script>

<style>
</style>